import { ReactNode } from "react";
import useModalContext, { useModalContextReturn } from "../hooks/use-modal-context";

export interface ModalContextExtractorProps<T = any> {
    children?: (modalContext: useModalContextReturn<T>) => ReactNode
}

export function ModalContextExtractor<T = any>({
    children
}: ModalContextExtractorProps<T>) {
    const modalContext = useModalContext<T>();
    return children && children(modalContext);
}

export interface ModalValueExtractorProps<T = any> {
    children?: (value: T) => ReactNode
}

export function ModalValueExtractor<T = any>({
    children
}: ModalValueExtractorProps<T>) {
    const { value } = useModalContext<T>();
    return children && children(value);
}